/**
 * Internal dependencies
 */
export type SaveRecipeFromListDatalayerProps = {
	itemListName: string;
};

/**
 * Pushes an event to the data layer when a recipe is saved from a list in Keittokirja.
 * This is used for analytics tracking.
 * @param {SaveRecipeFromListDatalayerProps} payload              - The payload containing recipe details.
 * @param {string}                           payload.itemListName - The name of the item list from which the recipe was saved.
 * @return {void}
 */
export function pushKeittokirjaSaveRecipeFromList({
	itemListName,
}: SaveRecipeFromListDatalayerProps): void {
	const isProduction = Boolean(window.valioAnalytics.isProduction);
	const datalayerObject = {
		event: 'keittokirja_save_recipe_from_list',
		item_list_name: itemListName,
	};

	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push(datalayerObject);

	if (!isProduction) {
		// eslint-disable-next-line no-console
		console.log('🔍 DataLayer: keittokirja_save_recipe_from_list', datalayerObject);
	}
}
